<template>
<v-container v-if="!isMobile">
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
      <v-spacer></v-spacer>

      <div class="pa-1">
   <v-select
          :items="location"
          item-value="_id"
          v-model="locationItem"
          @change="updateLocation"
          hide-details
          :item-text="
                        (location) => {
                          return (
                              location.location
                          );
                          }
                        "
          prepend-icon="mdi-map-marker"
          solo
          style="font-size: 15px;"
        ></v-select>
   </div>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 15px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 15px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
              <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
             <v-btn
      :loading="loading5"
      :disabled="loading5"
      :color="!timer ? 'red' : 'green'"
      :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text' "
      @click="timer = !timer, loader = 'loading5'"
      fab
      small
      v-bind="attrs"
      v-on="on" 
    >
      <v-icon dark>
        {{ !timer ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
     </template>
      <span> {{ !timer ? 'Enable Auto Refresh Page' : 'Disable Auto Refresh Page' }}</span>
    </v-tooltip>
    </v-app-bar>
  </nav>

  <v-row justify="center" align="center">
    <v-col cols="3">
<div class="wave-container">
<p>2440mm</p><p style="padding-top: 25px;">2000mm</p><p style="padding-top: 30px;">1220mm</p><p style="padding-top: 20px;">1000mm</p><p style="padding-top: 25px;">0mm</p>
  <div class="wave" :style="cssProps"></div>
</div>
    </v-col>
    <v-col cols="2">
      <v-container>
        <p align="center">Current Tank Level</p>
<v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recently
      </div>
      <div style="font-size:18px;color:black;">
       {{ waterConv[0] }}<span style="font-size:15px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
 <v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
       Filled
      </div>
      <div style="font-size:18px;color:black;">
       {{ (waterPercent.slice(-1)[0]).toFixed(2) }}<span style="font-size:15px;color:black;">%</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
  <v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Volume
      </div>
      <div style="font-size:18px;color:black;">
       {{ (waterVol.slice(-1)[0]).toFixed(2) }}<span style="font-size:15px;color:black;">L</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
    </v-col>
     <v-col cols="2">
      <v-container>
        <p align="center">Refilled</p>
<v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recently
      </div>
      <div style="font-size:18px;color:black;">
       {{ this.positiveSum }}<span style="font-size:15px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
        <p align="center">Consumption</p>
  <v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recently
      </div>
      <div style="font-size:18px;color:black;">
       {{ this.negativeSum }}<span style="font-size:15px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
    </v-col>
    <v-col cols="2">
      <v-container>
        <p align="center">Total Collected Rain Water</p>
<v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recently(Max)
      </div>
      <div style="font-size:18px;color:black;">
       {{ Math.max.apply(Math, this.waterSub) }}<span style="font-size:15px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
        <p align="center">Total Consumed Rain Water</p>
  <v-card
    class="text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recently(Max)
      </div>
      <div style="font-size:18px;color:black;">
       {{ Math.min.apply(Math, this.waterSub) }}<span style="font-size:15px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
    </v-col>
  </v-row>
  <v-row>     
      <apexchart width="800" height="250" :options="waterLevelChart" :series="waterLevelSeries"></apexchart>
  </v-row>
   <v-row>
      <apexchart width="800" height="250" :options="sufWaterLevelChart" :series="sufWaterLevelSeries"></apexchart>
  </v-row>
</v-container>

<v-container v-else>
   <v-row>
    <div class="pa-1">
   <v-select
          :items="location"
          item-value="_id"
          v-model="locationItem"
          @change="updateLocation"
          hide-details
          :item-text="
                        (location) => {
                          return (
                              location.location
                          );
                          }
                        "
          prepend-icon="mdi-map-marker"
          solo
          style="font-size: 15px;"
        ></v-select>
   </div>
   <v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  > <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
              <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
             <v-btn
      :loading="loading5"
      :disabled="loading5"
      :color="!timer ? 'red' : 'green'"
      :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text' "
      @click="timer = !timer, loader = 'loading5'"
      fab
      small
      v-bind="attrs"
      v-on="on" 
    >
      <v-icon dark>
        {{ !timer ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
     </template>
      <span> {{ !timer ? 'Enable Auto Refresh Page' : 'Disable Auto Refresh Page' }}</span>
    </v-tooltip>
   </v-container>
    </v-row>
<div class="wave-container">
<p>2440mm</p><p style="padding-top: 25px;">2000mm</p><p style="padding-top: 30px;">1220mm</p><p style="padding-top: 20px;">1000mm</p><p style="padding-top: 25px;">0mm</p>
  <div class="wave" :style="cssProps"></div>
</div>
    <v-row justify="center" align="center">
   
    <v-col>
      <v-container>
        <p style="font-size:10px;color:black;">Current Tank Level</p>
<v-card
    class="text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recently
      </div>
      <div style="font-size:12px;color:black;">
       {{ waterConv.slice(-1)[0] }}<span style="font-size:10px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
 <v-card
    class="text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
       Filled
      </div>
      <div style="font-size:12px;color:black;">
       {{ waterPercent.slice(-1)[0] }}<span style="font-size:10px;color:black;">%</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
  <v-card
    class="text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Volume
      </div>
      <div style="font-size:12px;color:black;">
       {{ waterVol.slice(-1)[0] }}<span style="font-size:10px;color:black;">L</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
    </v-col>
     <v-col>
      <v-container>
        <p style="font-size:10px;color:black;">Refilled</p>
<v-card
    class="text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recently
      </div>
      <div style="font-size:12px;color:black;">
       {{ this.positiveSum }}<span style="font-size:10px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
        <p style="font-size:10px;color:black;">Consumption</p>
  <v-card
    class="text-center"
    color="white"
    dark
    max-width="80"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recently
      </div>
      <div style="font-size:12px;color:black;">
       {{ this.negativeSum }}<span style="font-size:10px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
    </v-col>
    <v-col>
      <v-container>
        <p style="font-size:10px;color:black;">Total Collected Rain Water</p>
<v-card
    class="text-center"
    color="white"
    dark
    max-width="100"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recently(Max)
      </div>
      <div style="font-size:12px;color:black;">
       {{ Math.max.apply(Math, this.waterSub) }}<span style="font-size:10px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
      <v-container>
        <p style="font-size:10px;color:black;">Total Consumed Rain Water</p>
  <v-card
    class="text-center"
    color="white"
    dark
    max-width="100"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:10px;color:black;">
        Recently(Max)
      </div>
      <div style="font-size:12px;color:black;">
       {{ Math.min.apply(Math, this.waterSub) }}<span style="font-size:10px;color:black;">mm</span>
      </div>
    </v-card-text>
</v-card>
      </v-container>
    </v-col>
  </v-row>
  <v-row>     
      <apexchart width="380" height="220" :options="waterLevelChart" :series="waterLevelSeries"></apexchart>
  </v-row>
   <v-row>
      <apexchart width="380" height="220" :options="sufWaterLevelChart" :series="sufWaterLevelSeries"></apexchart>
  </v-row>
</v-container>

</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts'

Vue.component("apexchart", VueApexCharts);

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Water Level Tank',
          disabled: true,
          href: '',
        },
        {
          text: 'Overview',
          disabled: true,
          href: '',
        },
      ],
      values1: moment().subtract(24, "hour"),
      values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
    timer: true,
    loader: null,
    loading5: false,
    isMobile: true,
    location: [],
    locationItem: [],
    waterTank: [],
    waterLevel: [],
    waterSub: [],
    waterPercent: [],
    waterVol: [],

    waterLevelChart: {
        chart: {
          type: "line",
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
        },
        stroke: {
        show: true,
        curve: 'smooth',
        lineCap: 'butt',
        colors: undefined,
        width: 2,
        dashArray: 0,      
        },
      },
      WaterLevelSeries: [
        {
          data: [],
        },
      ],
      sufWaterLevelChart: {
        chart: {
          type: "bar",
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        colors: [
          function({ value }) {
            if (value < 0) {
              return '#FF0000'
            } else {
              return '#008efa'
            }
          }
        ]
      },
      sufWaterLevelSeries: [
        {
          data: [],
        },
      ],

  }),
  computed: {
    cssProps() {
      return {
        '--height': (this.waterPercent.slice(-1)[0] * 4) + '%'
      }
    }
  },
  mounted() {
    this.loadsBoard();
    this.loadsLocation();
    this.onResize();
    this.intervalFetchData();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    intervalFetchData: function () {
    setInterval(() => {    
    if(this.timer == true){     
      this.loadsBoard()}
       }, 300000); 
    },
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
    },
    loadsLocation: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/location-water-tank";
      axios.get(apiURL).then(res => {
      this.location = res.data;
      this.locationItem = this.location[0]._id;
      this.loadsBoard();
      }).catch(error => {
      console.log(error)
      });
    },
    loadsBoard: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/water-tank/"+ this.locationItem + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
    axios.get(apiURL).then(res => {
    this.waterTank = res.data;
    this.waterLevel = res.data.map((water) => water.fields.water_level);
    this.waterConv = this.waterLevel.map((x) => 2057 - x); 
    this.waterSub = this.waterConv.slice(1).map((v, i) => v - this.waterConv[i]);
    this.waterPercent = this.waterConv.map((x) => (x / 2057) * 100);
    this.waterVol = this.waterConv.map((x) => (x * 1220 * 3660) / 1000000);
    this.positive = this.waterSub.filter(posNumber => posNumber >= 0);
    this.negative = this.waterSub.filter(negNumber => negNumber < 0);
    this.positiveSum = this.positive.reduce((sumSoFar, current) => sumSoFar + current, 0);
    this.negativeSum = this.negative.reduce((sumSoFar, current) => sumSoFar + current, 0);

    let waterLevelFormat = this.waterTank.map((e, i) => {
      return {
        x: e.timestamp,
        y: this.waterConv[i],
        };
      });

    this.waterLevelSeries = [
        {
          name: "Water Tank Level",
          data: waterLevelFormat,
        },
    ];

    let sufWaterLevelFormat = this.waterTank.map((e, i) => {
      return {
        x: e.timestamp,
        y: this.waterSub[i],
      };
    });

    this.sufWaterLevelSeries = [
      {
        name: "Water Level Distance in mm",
        data: sufWaterLevelFormat,
      },
    ];

    }).catch(error => {
    console.log(error)
    });
  },
  updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsBoard();
    },
  updateLocation(){
      this.loadsBoard();
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 500)

        this.loader = null
      },
    },
}
</script>

<style>
.wave-container {
  position: relative;
  background-color: #2A73FE;
  width: 250px;
  height: 280px;
}

.wave {
  position: absolute;
  bottom: 0%;
  width: 200px;
  height: var(--height);
}

.wave::before {
  content: "";
  background-color: #fff;
  opacity: 0.5;
  position: absolute;
  left: -65%;
  bottom: 25%;
  width: 380px;
  height: 280px;
  -webkit-animation: spin 8s linear infinite;
  -moz-animation: spin 8s linear infinite;
  animation: spin 8s linear infinite;
}

.wave::after {
  content: "";
  background-color: #fff;
  opacity: 0.5;
  position: absolute;
  left: -65%;
  bottom: 25%;
  width: 380px;
  height: 280px;
  -webkit-animation: spin 10s linear infinite;
  -moz-animation: spin 10s linear infinite;
  animation: spin 10s linear infinite;
}

</style>